



import CarpsaleEditComponent from "@/components/admin/carpsale/carpsaleEditComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpsaleEditPage",
  components: {
    CarpsaleEditComponent,
  },
})
export default class CarpsaleListPage extends Vue {}
